import { CommonModule } from '@angular/common'
import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { MatMenu } from '@angular/material/menu'
import { Router, RouterModule } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
@Component({
  selector: 'ddc-three-dots',
  templateUrl: './ddc-three-dots.component.html',
  styleUrl: './ddc-three-dots.component.scss',

  imports: [AngularMaterialsModules, CommonModule, RouterModule],
})
export class DdcThreeDotsComponent {
  @Input() mode: string
  @Input() dynamicRoute: string
  @Input() isMine: boolean

  @Output() openWordDialog = new EventEmitter<void>()
  @Output() openWordEditDialog = new EventEmitter<void>()
  @Output() openWordDeleteDialog = new EventEmitter<void>()

  @Output() openPairDialog = new EventEmitter<void>()
  @Output() openPairEditDialog = new EventEmitter<void>()
  @Output() openPairDeleteDialog = new EventEmitter<void>()

  @Output() openDicDeleteDialog = new EventEmitter<void>()
  @Output() openDicDialog = new EventEmitter<void>()

  @ViewChild('lib_word_1') lib_word_1: MatMenu
  @ViewChild('lib_pair_1') lib_pair_1: MatMenu
  @ViewChild('lib_dic_1') lib_dic_1: MatMenu
  menu: MatMenu

  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
  ) {}

  ngAfterViewInit(): void {
    if (this.mode === 'lib_word_1') {
      this.menu = this.lib_word_1
    } else if (this.mode === 'lib_pair_1') {
      this.menu = this.lib_pair_1
    } else if (this.mode === 'lib_dic_1') {
      this.menu = this.lib_dic_1
    }
    this.cdr.detectChanges() // Manually trigger change detection
  }

  onOpenWordDialog(): void {
    this.openWordDialog.emit()
  }

  onOpenWordEditDialog(): void {
    this.openWordEditDialog.emit()
  }
  onOpenWordDeleteDialog(): void {
    this.openWordDeleteDialog.emit()
  }

  onOpenPairDialog(): void {
    this.openPairDialog.emit()
  }

  onOpenDicDeleteDialog(): void {
    this.openDicDeleteDialog.emit()
  }

  onOpenPairEditDialog(): void {
    this.openPairEditDialog.emit()
  }
  onOpenPairDeleteDialog(): void {
    this.openPairDeleteDialog.emit()
  }

  onOpenDic(): void {
    this.openDicDialog.emit()
  }
}
